import { coworkingAmenitiesOptions } from '../../../scripts/enums/coworking-amenities';
import { splitItemsToColumns } from '../../../scripts/utils/splitItemsToColumns';
import './amenities.css';

const splitToTwoColumns = splitItemsToColumns(2);

export default [
  '$scope',
  'deviceService',
  function ($scope, deviceService) {
    this.isMobile = deviceService.isMobile;

    if (!this.ad.coworking) {
      this.ad.coworking = {};
    }

    if (!this.ad.coworking.amenities) {
      this.ad.coworking.amenities = [];
    }

    this.items = coworkingAmenitiesOptions.map(item => ({
      ...item,
      value: this.ad.coworking.amenities.includes(item.key),
    }));

    this.columns = splitToTwoColumns(this.items);

    $scope.$watch(
      () => this.ad.coworking.amenities,
      newAmenities => {
        this.items = coworkingAmenitiesOptions.map(item => ({
          ...item,
          value: newAmenities?.includes(item.key) || false,
        }));

        this.columns = splitToTwoColumns(this.items);
      },
    );

    this.onChange = item => {
      if (item.value) {
        this.ad.coworking.amenities = [...this.ad.coworking.amenities, item.key];
      } else {
        this.ad.coworking.amenities = this.ad.coworking.amenities.filter(el => el !== item.key);
      }
    };
  },
];
